/* Shiro Drip — puntos de navegación de la galería de producto */
(function () {
  function bind(wrapper) {
    if (wrapper.dataset.dotsBound === 'true') return;

    var slider = wrapper.closest('slider-component');
    var list = slider ? slider.querySelector('.slider') : null;
    var dots = Array.prototype.slice.call(wrapper.querySelectorAll('.slider-counter__link'));

    if (!slider || !list || dots.length < 2) {
      if (dots.length < 2) wrapper.hidden = true; // una sola foto: sin puntos
      return;
    }

    wrapper.dataset.dotsBound = 'true';

    function setActive(page) {
      dots.forEach(function (dot, i) {
        var on = i === page - 1;
        dot.classList.toggle('slider-counter__link--active', on);
        if (on) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    slider.addEventListener('slideChanged', function (event) {
      if (event.detail && event.detail.currentPage) setActive(event.detail.currentPage);
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var items = list.querySelectorAll('.product__media-item, .slider__slide, li');
        if (!items[index]) return;
        list.scrollTo({ left: items[index].offsetLeft - list.offsetLeft, behavior: 'smooth' });
        setActive(index + 1);
      });
    });

    setActive(1);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-gallery-dots]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // El editor de temas vuelve a pintar la sección al cambiar ajustes
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
